import styled from "styled-components";
import {IconContainerDefaultBox} from "./icon-container.default.box";

export const IconContainerMrgreenBox = styled(IconContainerDefaultBox)`
    color: ${props => props.theme.colors.brandPrimaryDark};
`